/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { getRequest, postRequest, putRequest } from '../../utils/client/client';

const service = {
  getSurvey(surveyId) {
    const url = `/survey_builder/api/surveys/${surveyId}`;

    return getRequest({ url });
  },
  createSurvey(surveyData, csrfToken) {
    return postRequest({
      url: '/survey_builder/api/surveys',
      data: JSON.stringify(surveyData),
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': csrfToken,
      },
    }).then(resData => {
      const newPath = `/survey_builder/${resData.id}`;
      history.replaceState(undefined, undefined, newPath);

      return resData;
    });
  },
  updateSurvey(surveyId, surveyData, csrfToken) {
    return putRequest({
      url: `/survey_builder/api/surveys/${surveyId}`,
      data: JSON.stringify(surveyData),
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': csrfToken,
      },
    });
  },
  showError(message, dispatch) {
    const alert = {
      type: 'error',
      message,
    };
    dispatch('alerts/show', alert, { root: true });
  },
  confirm(message, dispatch) {
    const modal = {
      type: 'GenericConfirm',
      data: { message },
    };

    return dispatch('modals/show', modal, { root: true });
  },
};

export default service;
